export default "__VITE_ASSET__BZWK_KnX__"